export default __webpack_public_path__ + "static/media/turbinado_dry.4f49b9cd.otf";